import { TCsvObject, WrongTypeError } from '@acme/core'
import { Typography } from '@mui/material'
import { ChangeEvent, useState } from 'react'
import ApiService from 'service/api/api.service'
import { toast } from 'sonner'
import Dialog from '../../guides/Dialog'
import { FormFile } from '../Form'
import IconeAjuda from '../IconeAjuda'

interface IProps {
    name: string
    api: InstanceType<typeof ApiService<any, any, any>>
    onDecodedCsv: (dados: string) => TCsvObject[]
}

export default function ModalImportar({ api, name, onDecodedCsv }: IProps) {
    const [paraImportar, setParaImportar] = useState<Array<any | null>>([])
    const [erro, setErro] = useState<string | null>(null)
    const { mutateAsync } = api.mutations.useCreate()

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (!event.target.files) return
        setParaImportar([])
        setErro(null)

        const fileUploaded: File = event.target.files[0]

        if (fileUploaded.type !== 'text/csv')
            return setErro(
                'Tipo de arquivo inválido, o formato suportado é CSV',
            )

        const reader = new FileReader()
        reader.readAsArrayBuffer(fileUploaded)
        reader.onload = e => {
            if (!e.target?.result) return
            try {
                const decoder = new TextDecoder('utf-8')
                const dados = decoder.decode(
                    new Uint8Array(e.target.result as ArrayBuffer),
                )
                setParaImportar(onDecodedCsv(dados))
            } catch (error) {
                if (error instanceof WrongTypeError) {
                    setErro(
                        `${error.message} na coluna ${error.header} da linha ${error.line}`,
                    )
                } else {
                    setErro(
                        'Erro ao ler o arquivo, verifique se as colunas estão corretas',
                    )
                }
            }
        }
    }

    return (
        <Dialog.Root
            height="auto"
            onSubmit={async () => {
                return mutateAsync(paraImportar.filter(Boolean) as any, {
                    onError: erro => {
                        throw toast.error(erro.message.toString())
                    },
                    onSuccess: () => {
                        toast.success(`${name} importados com sucesso`)
                        api.invalidateQueries()
                    },
                })
            }}
        >
            <Dialog.Title>
                <span>Importar {name}</span>
                <IconeAjuda>
                    O arquivo deve ser um csv com os mesmos campos do arquivo
                    gerado na exportação.
                </IconeAjuda>
            </Dialog.Title>
            <Dialog.Content>
                <FormFile
                    name="arquivo"
                    notPreview
                    onChange={handleChange}
                    helperText={
                        !erro ? (
                            <Typography variant="body2">
                                <strong>
                                    {paraImportar.filter(Boolean).length}
                                </strong>{' '}
                                {name} para importar
                            </Typography>
                        ) : (
                            <Typography variant="body2" color="error">
                                {erro}
                            </Typography>
                        )
                    }
                />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.PrimaryButton closeOnSubmit>
                    Importar
                </Dialog.Actions.PrimaryButton>
                <Dialog.Actions.SecondaryButton />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
